// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"Layout_flexRow__CE4eR","flexCol":"Layout_flexCol__vk7Em","bottom":"Layout_bottom__ACvwl","top":"Layout_top__UQYww","right":"Layout_right__NOjn_"};